import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGE } from "services/general";

/**
 * MoreToolsUserCard — signed-in user summary + logout, shown at the top of
 * the phone full-screen drawer.
 */
const MoreToolsUserCard = ({
  isDark,
  user,
  fullName,
  role,
  initial,
  onNavigate,
  onLogout,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`p-3.5 rounded-2xl flex items-center justify-between gap-3 border ${
        isDark
          ? "bg-white/[0.04] border-white/[0.08]"
          : "bg-[#F9FAFB] border-gray-100"
      }`}
    >
      <Link
        to={`/${LANGUAGE}/profile`}
        onClick={onNavigate}
        className="flex items-center gap-3 flex-1 min-w-0"
      >
        {user?.photo_url ? (
          <img
            src={user.photo_url}
            alt={fullName || "User"}
            className="w-12 h-12 rounded-full object-cover shrink-0"
          />
        ) : (
          <span className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-[#43c3da] text-white text-base font-bold flex items-center justify-center shrink-0">
            {initial}
          </span>
        )}
        <div className="min-w-0 flex-1 text-start">
          <div
            className={`text-sm font-bold truncate ${
              isDark ? "text-white" : "text-heading"
            }`}
          >
            {fullName || t("pages.profile")}
          </div>
          {role && (
            <div
              className={`text-xs truncate ${
                isDark ? "text-white/60" : "text-text-muted"
              }`}
            >
              {role}
            </div>
          )}
        </div>
      </Link>

      {onLogout && (
        <button
          type="button"
          onClick={onLogout}
          className="w-10 h-10 rounded-xl bg-danger/10 text-danger hover:bg-danger/20 flex items-center justify-center transition-colors shrink-0 border-0 cursor-pointer"
          title={t("logout")}
          aria-label={t("logout")}
        >
          <FontAwesomeIcon icon={faRightFromBracket} className="text-sm" />
        </button>
      )}
    </div>
  );
};

export default MoreToolsUserCard;
